import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RequireAuth } from '../features/auth/components/RequireAuth';
import LoginForm from '../features/auth/components/LoginForm';
import ShipmentsPage from '../features/shipments/components/ShipmentsPage';
import TrackingPage from '../features/tracking/components/TrackingPage';
import AiPage from '../features/ai/components/AiPage';
import { AppShell } from '../components/layout/AppShell';
import { useAuth } from './provider';
import SettingsPage from 'features/settings/SettingsPage';
import Dashboard from 'features/dashboard/Dashboard';

function FullScreenSpinner() {
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
    </div>
  );
}

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <FullScreenSpinner />;
  }

  if (isAuthenticated) {
    return <Navigate to="/shipments" replace />;
  }

  return <>{children}</>;
};

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginForm />
      </PublicRoute>
      }
      />
      <Route path='/dashboard' element={<RequireAuth><AppShell><Dashboard /></AppShell></RequireAuth>} />
      <Route path="/shipments/track/public" element={<AppShell minimal={true}><TrackingPage isPublic={true} /></AppShell>} />
      <Route
        path="/shipments/in-transit"
        element={
          <RequireAuth>
            <AppShell>
              <ShipmentsPage status='in_transit' />
            </AppShell>
          </RequireAuth>
        }
      />
      <Route
        path="/shipments/delivered"
        element={
          <RequireAuth>
            <AppShell>
              <ShipmentsPage status='delivered' />
            </AppShell>
          </RequireAuth>
        }
      />
      <Route
        path="/shipments/local"
        element={
          <RequireAuth>
            <AppShell>
              <ShipmentsPage status='local' />
            </AppShell>
          </RequireAuth>
        }
      />
      <Route
        path="/shipments/:cnNumber/track"
        element={
          <RequireAuth>
            <AppShell>
              <TrackingPage />
            </AppShell>
          </RequireAuth>
        }
      />
      <Route
        path="/ai"
        element={
          <RequireAuth>
            <AppShell>
              <AiPage />
            </AppShell>
          </RequireAuth>
        }
      />
      <Route path="/settings" element={<RequireAuth><AppShell><SettingsPage /></AppShell></RequireAuth>}  />
      <Route
        path="/"
        element={<Navigate to="/shipments/in-transit" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/shipments/in-transit" replace />}
      />
    </Routes>
  );
};
